export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-4 whitespace-nowrap">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            关于91免费
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/60 p-8 md:p-10">
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
              91免费是一个专注于<strong>免费电影在线观看</strong>和高清视频免费看的聚合平台。我们致力于为广大影迷提供便捷的<strong>免费在线视频</strong>入口，整合最新<strong>免费电影</strong>资源与热门视频网站推荐。平台每日追踪全网更新，覆盖动作、喜剧、悬疑、科幻、爱情、动漫等全品类内容，让每一位用户都能轻松找到心仪的影视作品。从 <strong>91免费在线视频</strong> 到 <strong>91免费电影</strong>，我们始终坚持免费、安全、流畅的观影理念，打造值得信赖的<strong>免费在线视频平台</strong>。
            </p>
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
              <div>
                <p className="text-2xl md:text-3xl font-bold text-primary-500">8000+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">影视资源</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-bold text-accent-500">50+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">每日更新</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-bold text-primary-500">1080P</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">高清画质</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-bold text-accent-500">0元</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">完全免费</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}